import { render } from "./resetPhone.vue?vue&type=template&id=038ade38"
import script from "./resetPhone.vue?vue&type=script&lang=js"
export * from "./resetPhone.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__